import styled from 'styled-components';

export const NodeInformationStyle = styled.div`
  flex: 1;
  display: flex;
  padding: 4px 2px 12px 2px;
  flex-direction: column;
  max-width: 242px;

  .close-cont {
    display: flex;
    justify-content: flex-end;
    color: #98A2B3;

    span {
      font-size: 10px;
      cursor: pointer;
    }
  }

  .s-label {
    font-weight: 600;
    font-size: 10px;
    color: #6C737F;
    margin-bottom: 9px;

    span {
      margin-left: 5px;
    }
  }

  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 15px;

    .header {
      display: flex;

      .content {
        flex: 1;
        display: flex;
        flex-direction: column;

        .id {
          color: #6C737F;
          font-size: 10px;
          margin-bottom: 4px;
        }

        .label {
          color: black;
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 0px;
        }
      }
    }

    .subjects-shared {
      .items {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;

        .tag {
          border: 1px solid #D0D5DD;
          padding: 2px 8px;
          color: #111927;
          font-weight: 500;
          font-size: 10px;
          border-radius: 6px;
        }
      }
    }

    .last-published {
      p {
        font-size: 10px;
        color: #384250;
        font-weight: 500;
      }
    }

    .lir-sources {
      display: flex;
      flex-direction: column;
      max-height: 265px;

      .items {
        border-top: 1px solid #F0F0F0;
        overflow-y: auto;
        max-height: 400px;

        .item {
          padding-top: 8px;
          padding-bottom: 8px;
          border-bottom: 1px solid #F0F0F0;

          label {
            font-size: 14px;
            font-weight: 700;
            margin-bottom: 0px;

            a {
              font-weight: 500;
              color: var(--mmt-primary-70);
              text-decoration-line: underline;
              cursor: pointer;
            }
          }

          p {
            margin-bottom: 0px;
            font-size: 14px;
            font-weight: 500;
            color: #001529;
          }
        }
      }
    }
  }

  .applications {
    .apps-list {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .app-cont {
      display: flex;
      gap: 4px;

      .icon-cont {
        padding: 0px 5px;
        background: #FF78754D;
        border-radius: 100%;

        &.cadd {
          background: #D9F7BE80;
        }
      }
      
      .label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-weight: 500;
        font-size: 10px;
        color: #111927;
      }
    }
  }

  .actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const LirNodeLabelStyle = styled.div`
  display: flex;
  margin-top: -1px;
  padding: 10px;

  .bullet {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background: #9A76E8;
    margin-right: 5px;
  }

  p {
    margin: 0px;
    font-size: 8px;
    padding: 0px;
    margin-top: -1px;  
    color: #001529 !important;
  }
`;

export const DefaultNodeLabelStyle = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  padding: 10px;

  .flex-c {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .label {
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    color: #101828;
    margin-bottom: 2px;
  }

  .applications-cont {
    margin-bottom: 5px;
    display: flex;

    label {
      font-size: 7px;
      font-weight: 500;
      color: #101828;
      margin-bottom: 0px;
    }
    .app-bullet {
      width: 7px;
      height: 7px;
      border-radius: 100% 100% 100% 0;
    }
  }

  .info {
    display: flex;
    gap: 3px;

    .info-cont {
      display: flex;
      background: rgba(12, 147, 244, 0.3);
      border-radius: 100px; 
      padding: 3px 8px;

      svg {
        width: 8px;
        height: 7px;
        margin-right: 2px;
      }

      p {
        font-size: 6px;
        margin-bottom: 0px;
        font-weight: 500;
        color: white;
      }

      &.id {
        p {color: #0C93F4;}
      }

      &.ownData {
        background: var(--mmt-primary-60);
      }

      &._source {
        background: #1B5994;
      }

      &._client {
        background: #273F55;
      }
    }
  }
`;
